<template>
  <v-container>
    <v-layout row wrap>
    </v-layout>
        <iframe :src="src" ref="pdf" target="_blank" pagelayout="landscape" frameborder="0" style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px" height="100%" width="100%" > 
        </iframe>
  </v-container>
</template>

<script>
/* eslint-disable */
//import jsPDF from "jspdf";
import { mapActions } from "vuex";
import pdf from "vue-pdf";
import moment, { months } from 'moment';
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import SettingService from "@/services/SettingService";
import DocumentService from "@/services/DocumentService";
export default {
  components: {
    pdf
  },
  data() {
    return {
        earning:0,
        tax_pay:0,
        names:"",
        IDcards :"",
        src: "",
        json: {},
        newjson: {},
        jsonData : [],
        indexs:"",
        cumulativeSSs:"",
        last_salarys:"",
        totalsalary :0,
        totalss:0,     
        totaltext:[]   
    };
  },
  created() {
      this.year = this.$route.params.year;
      this.branch = this.$route.params.branch;
      this.department = this.$route.params.department;
      this.process();
    
  },
  methods: {
     goto(path) {
      this.$router.push("/" + path);
    },
    
     groupBy(array, key) {
      const result = {};
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    process() {
      let v = this;
      let branchs = "";
      if(this.branch == "ALL"){
        branchs = "";
          DocumentService.getTaxDetailByYearAllEmp( this.year,branchs,this.department)
        .then(res => {
          console.log(res);
          this.json = res.data;
          this.tabledata = true;
          console.log("this.json: ", this.json);
          //**new array **//
          this.newjson.from_date = this.json.from_date;
          this.newjson.to_date = this.json.to_date;
          this.newjson.total_earning = this.json.total_earning;
          this.newjson.total_tax = this.json.total_tax;
          this.newjson.details = [];
          var sumearning = 0;
          var sumtax_pay = 0;
          this.newjson.details = [];
          const unique = this.groupBy(this.json.details, "emp_code");
          console.log(unique);
          let keys = "";
          let index = 0;
          for (var key in unique) {
            console.log("key: ", key);
            let emp_code = "";
            let id_card = "";
            let emp_name = "";
            let payDate = "";
            let address = "";
            let j = 0;
            sumearning = 0;
            sumtax_pay = 0;
            unique[key].forEach(element => {
              if (j == 0) {
                //values += element.packaging_name;
              } else if (j != 0) {
                //values += "/" + element.packaging_name;
              }
              emp_code = element.emp_code;
              id_card = element.id_card;
              emp_name = element.emp_name;
              payDate = element.payDate;
              address = element.address;
              sumearning += element.earning;
              sumtax_pay += element.tax_pay;
              j++;
            });
            this.newjson.details.push({
              emp_code: emp_code,
              id_card: id_card,
              emp_name: emp_name,
              payDate: payDate,
              address: address,
              earning: sumearning,
              tax_pay: sumtax_pay
            });
          }
          console.log("json: ", this.json);
          console.log("new json: ", this.newjson);
         this.getPDFByYear();
        })
        .catch(err => {
          console.log(err);
          0;
        });
      
      }else{
        branchs = this.branch;
          DocumentService.getTaxDetailByYearAllEmp( this.year,branchs,this.department)
        .then(res => {
          console.log(res);
          this.json = res.data;
          this.tabledata = true;
          console.log("this.json: ", this.json);
          //**new array **//
          this.newjson.from_date = this.json.from_date;
          this.newjson.to_date = this.json.to_date;
          this.newjson.total_earning = this.json.total_earning;
          this.newjson.total_tax = this.json.total_tax;
          this.newjson.details = [];
          var sumearning = 0;
          var sumtax_pay = 0;
          this.newjson.details = [];
          const unique = this.groupBy(this.json.details, "emp_code");
          console.log(unique);
          let keys = "";
          let index = 0;
          for (var key in unique) {
            console.log("key: ", key);
            let emp_code = "";
            let id_card = "";
            let emp_name = "";
            let payDate = "";
            let address = "";
            let j = 0;
            sumearning = 0;
            sumtax_pay = 0;
            unique[key].forEach(element => {
              if (j == 0) {
                //values += element.packaging_name;
              } else if (j != 0) {
                //values += "/" + element.packaging_name;
              }
              emp_code = element.emp_code;
              id_card = element.id_card;
              emp_name = element.emp_name;
              payDate = element.payDate;
              address = element.address;
              sumearning += element.earning;
              sumtax_pay += element.tax_pay;
              j++;
            });
            this.newjson.details.push({
              emp_code: emp_code,
              id_card: id_card,
              emp_name: emp_name,
              payDate: payDate,
              address: address,
              earning: sumearning,
              tax_pay: sumtax_pay
            });
          }
          console.log("json: ", this.json);
          console.log("new json: ", this.newjson);
         this.getPDFByYear();
        })
        .catch(err => {
          console.log(err);
          0;
        });
      
      }
          
    },
    async getPDFByYear() {
        let v = this;
      NProgress.start();
      try {
        let tmpResult = this.newjson;
        // gen items
        let rowIndex = 0;
        let index =0;
        let i = 0;
          console.log(tmpResult.data)
        tmpResult.details.forEach(element => {
            //console.log(element)
          index = index;
          rowIndex++;
              v.name = element.emp_name.split('(')[0] ;//ชื่อพนักงาน
              if(element.id_card != null){
                v.IDcard = v.IDcardformat(element.id_card);//บัตรประชาชน
              }else{
                 v.IDcard = " ";
              }
              if(element.earning != null){
                 v.earning = v.thousandSep(element.earning);//เงินเดือน
              }else{
                v.earning = v.thousandSep(0);
              }
              if(element.tax_pay != null){
                v.tax_pay = v.thousandSep(element.tax_pay);//ภาษี
              }else{
                v.tax_pay =v.thousandSep(0);
              }
              v.month = moment(element.createDateTime).format('M');
              v.year = moment(element.createDateTime).format('YYYY');
              v.salary =  element.earning;
              v.ss = element.tax_pay; 
              v.add = element.address;
              // console.log("name",v.name);
              // console.log("totalDeduct",element.totalDeduct);
              // console.log("total_balance",element.total_balance);
              
          if(element.totalEarning != 0 ){
           
                index++;
              i++;
              v.page++;
              v.ind = i+`\n\n\n`;
              v.names += v.name+`\n`+v.add+`\n\n`;
              v.IDcards += v.IDcard+`\n\n\n`;
              v.last_salarys += v.earning+`\n\n\n`;
              v.cumulativeSSs += v.tax_pay +`\n\n\n`;
              v.indexs += v.ind;
              v.totalsalary += v.salary;
              v.totalss += v.ss;
            
          
          }
          if(index == 6 ){
             v.jsonData.push(v.genSlipJson("before")); 
              v.names = "";
              v.IDcards="";
              v.last_salarys = ''
              v.cumulativeSSs = ''
              v.indexs = "";
            
              index=0;
          }else if(i == tmpResult.details.length){
            v.jsonData.push(v.genSlipJson("before"));
          }
          else if(rowIndex == tmpResult.details.length){
            v.jsonData.push(v.genSlipJson("before"));
          }
          
           console.log("i",i)
           console.log("index",index)
        });
         
        this.createpdf();
      } catch (err) {
        console.log(err);
      }
      NProgress.done();
    },
    thousandSep(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    IDcardformat(value) {
      var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
      var matches = v.match(/\d{1,13}/g);
      var match = matches && matches[0] || ''
      var parts = []

         parts.push(match.substring(0,1))
         parts.push(match.substring(1,5))
         parts.push(match.substring(5,10))
         parts.push(match.substring(10,12))
         parts.push(match.substring(12,13))
    

    if (parts.length) {
        return parts.join('-')
    } else {
        return value
    }
    },
    async getCompany() {
      NProgress.start();
      try {
        let tmpResult = await SettingService.getDataCompany();
        this.ltdName = tmpResult.data.content[0].companyname;
        this.process();
      } catch (err) {
        console.log(err);
      }
      NProgress.done();
    },

    createpdf() {
      let v = this;
      var pdfMake = require("pdfmake/build/pdfmake.js");
      //pdfMake.setFonts(fonts);
      pdfMake.fonts = {
        Sarabun: {
          normal:
            "https://fonts.gstatic.com/s/sarabun/v12/DtVjJx26TKEr37c9WBJDnlQN9gk.ttf",
          bold: "https://fonts.gstatic.com/s/sarabun/v12/DtVmJx26TKEr37c9YK5sulwm6gDXvwE.ttf",
          italics:
            "https://fonts.gstatic.com/s/sarabun/v12/DtVhJx26TKEr37c9aBBJmnYI5gnOpg.ttf",
          bolditalics:
            "https://fonts.gstatic.com/s/sarabun/v12/DtVkJx26TKEr37c9aBBxJlks7iLSrwFUlw.ttf",
        },
      };
      // if (pdfMake.vfs == undefined) {
      //   var pdfFonts = require("pdfmake/build/vfs_fonts.js");
      //   pdfMake.vfs = pdfFonts.pdfMake.vfs;
      // }

      // pdfMake.fonts = {
      //   THSarabunNew: {
      //     normal: "THSarabunNew.ttf",
      //     bold: "THSarabunNew-Bold.ttf",
      //     italics: "THSarabunNew-Italic.ttf",
      //     bolditalics: "THSarabunNew-BoldItalic.ttf"
      //   },
      //   Roboto: {
      //     normal: "Roboto-Regular.ttf",
      //     bold: "Roboto-Medium.ttf",
      //     italics: "Roboto-Italic.ttf",
      //     bolditalics: "Roboto-MediumItalic.ttf"
      //   }
      // };

      let docDefinition = {
        content: this.jsonData,
        pageOrientation: 'landscape',
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 3]
          },
          subheader: {
            fontSize: 14,
            bold: true
          },
           subtext: {
            fontSize: 12,
            bold: true
          }
        },
        defaultStyle: {
          font: "Sarabun",
          fontSize: 14,
        }
      };

      this.pdfDocGen = pdfMake.createPdf(docDefinition);

      this.pdfDocGen.getDataUrl(data => {
        this.src = data;
      });
    },
    genSlipJson(param) {
      let jSonResult = [
           {
          columns: [   
           
            {
              text: "ใบแนบ ภ.ง.ด.1ก",
              style: "header",
              alignment: "left",
             
            },
             {
              text: "เลขประจำตัวผู้เสียภาษีอากร (ของผู้มีหน้าที่หักภาษี ณ ที่จ่าย) ",
              style: "subheader",
              alignment: "right",
            },
            {
             
              width: 35,
              margin: [25,0,0,0],
              table: {
                widths: [5],
                heights: [10],
                headerRows: 1,
                body: [
                  [
                    { text: "" },
                  ],
                ]
              }, 
            },
             {
              text: "-",
              style: "subheader",
              alignment: "right",
              width: 15,
              margin: [5,0,0,0],
            },
             {
             
              width: 55,
              margin: [5,0,0,0],
              table: {
                widths: [5,5,5,5],
                heights: [10,10,10,10],
                headerRows: 1,
                body: [
                  [
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                  ],
                ]
              }, 
            },
            {
              text: "-",
              style: "subheader",
              alignment: "right",
              width: 15,
              margin: [5, 0, 0, 0],
            },
            {
               width: 70,
               margin: [5,0,0,0],
              table: {
                widths: [5,5,5,5,5],
                heights: [10,10,10,10,10],
                headerRows: 1,
                body: [
                  [
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    { text: "" }
                  ],
                ]
              }, 
            },
            {
              text: "-",
              style: "subheader",
              alignment: "right",
              width: 15,
              margin: [5,0,0,0],
            },
            {
              width: 27,
              margin: [5,0,0,0],
              table: {
                widths: [5,5],
                heights: [10,10],
                headerRows: 1,
                body: [
                  [
                    { text: "" },
                    { text: "" }
                  ],
                ]
              }, 
            },
             {
              text: "-",
              style: "subheader",
              alignment: "right",
              width: 15,
              margin: [5,0,0,0],
            },
                        {
               width: 10,
               margin: [5,0,0,0],
              table: {
                widths: [5],
                heights: [10],
                headerRows: 1,
                body: [
                  [
                    { text: "" }
                  ],
                ]
              }, 
            },
          ]
        },

        {
          columns: [
           {
              width:680,
              text: "ลำดับที่สาขา",
              style: "subheader",
              alignment: "right",
               margin: [5, 0, 5, 5],
            },
            {
              style: "text",
              alignment: "right",
               width: 150,
                margin: [7, 0, 5, 5],
              table: {
                widths: [5,5,5,5,5,5],
                heights: [10,10,10,10,10,10],
                headerRows: 1,
                body: [
                  [
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    { text: "" }
                  ],
                ]
              },
               
            },
          ]
        },
        
        {
          columns: [
            {
              
              width: 750,
              table: {
                widths: [50,200,300,90,90],
                headerRows: 1,
                body: [
                  [
                    { text: "ลำดับที่",alignment: "center", style: "subtext", },
                    { text: "เลขประจำตัวผู้เสียภาษีอากร (ของผู้มีเงินได้)",alignment: "center", style: "subtext",},
                    { text: "ชื่อผู้มีเงินได้(ให้ระบุให้ชัดเจนว่าเป็น นาย นาง นางสาว หรือยศ)"+"\n"+"ที่อยู่ของผู้มีเงินได้ (ให้ระบุเลขที่ ตรอก/ซอย ถนน ตำ บล/แขวง อำ เภอ/เขต จังหวัด)",alignment: "center", style: "subtext", },
                    { text: "จำนวนเงินได้ที่จ่ายทั้งปี ",alignment: "center", style: "subtext", },
                    { text: "จำนวนเงินภาษีที่หัก"+"\n"+"และนำส่งทั้งปี",alignment: "center", style: "subtext", }
                  ],
                  [
                    { text: this.indexs,alignment: "center", style: "subheader", },
                    { text: this.IDcards,alignment: "center", style: "subheader",},
                    { text: this.names,alignment: "left", style: "subheader",  margin: [15, 0, 5, 5],},
                    { text: this.last_salarys,alignment: "center", style: "subheader", },
                    { text: this.cumulativeSSs,alignment: "center", style: "subheader", }
                  ],
                
                ]
              },
              
            },
          
          ]
        },
         {
          columns: [
            {
               width: 577,
              text: "รวมยอดเงินได้และภาษีที่นำส่ง (นำ ไปรวมกับใบแนบ ภ.ง.ด.1ก แผ่นอื่น (ถ้ามี))",
                margin: [7, 5, 5, 5],
              style: "subheader",
              alignment: "right",
            },
            { 
             style: "text",
              alignment: "right",
              width: 750,
              table: {
                widths: [90,90],
                headerRows: 1,
                body: [
                  [
                    { text: this.thousandSep(this.totalsalary),alignment: "center", style: "subheader", },
                    { text: this.thousandSep(this.totalss),alignment: "center", style: "subheader",}
                  ],
                   [
                    { text: "",alignment: "center", style: "subheader", },
                    { text: "",alignment: "center", style: "subheader",}
                  ],
                ]
              },
               
            },
          ]
        },
     
        {
          columns: [
            {
              width: 576,
              text: "",
              style: "subheader",
              alignment: "left",
              pageBreak: param
            },
            { 
              width: 576,
              text: "",
              style: "subheader",
              alignment: "left",
              pageBreak: param
            },
          
          ]
        }
      ];
      return jSonResult;
    }
  },
};
</script>

<style lang="stylus" scoped>
.print {
  width: 100%;
  height :100%;


  table {
    width: 100%;
    border-bottom: 1px solid #F2F2F2;
  }

  table th {
    border-bottom: 1px solid #F2F2F2;
  }
}
</style>
